<template>
  <div>
    <div class="flex w-100">
      <!-- <div @click="editTrigger" :class="{'o-50': edit }"
           class="edit-button bg-primary ma2 br-100 flex items-center justify-center pointer">
        <font-awesome-icon class="white" icon="edit"/>
      </div>
      -->
      <div v-show="loading || !user" class="flex justify-center mt3 w-100">
        <clip-loader :loading="true" :color="color" :size="size"></clip-loader>
      </div>
      <form v-show="!loading && user" @submit.prevent="updateUser" class="w-100">
        <div class="flex flex-column justify-center f6">
          <p class="dark-red mh3 tc f7" v-if="error && input === ''">{{error}}</p>
          <div v-show="user" class="flex-ns justify-center">
            <div class="w-50-ns w-100 pa2-ns pa1 flex flex-column">
              <span class="dark-red f7"
                    v-if="$v.username.$error && !$v.username.required">{{ $t("error.usernameRequired") }}</span>
              <span class="dark-red f7" v-if="error && input === 'username'">{{error}}</span>
              <label class="f7 textColor" for="username">{{ $t("users.username") }}</label>
              <input class="w-100 input ph2" :class="{error: $v.username.$error || (error && input === 'username')}"
                     @blur="$v.username.$touch" v-model="username" name="username" id="username"
                     :placeholder="$t('users.username')" :disabled="!edit">
            </div>
            <div class="w-50-ns w-100 flex" :class="{'input-margin': $v.username.$error}">
              <div class="flex flex-column pa2-ns pa1 w-50">
                <label class="f7 textColor" for="name">{{ $tc('users.name',2) }}</label>
                <input class="w-100 input ph2" v-model="name" name="name" id="name"
                       :placeholder="$tc('users.name',2)" :disabled="!edit">
              </div>
              <div class="flex flex-column pa2-ns pa1 w-50">
                <label class="f7 textColor" for="surname">{{ $t("users.surnames") }}</label>
                <input class="w-100 input ph2" v-model="surname" name="surname" id="surname"
                       :placeholder="$t('users.surnames')" :disabled="!edit">
              </div>
            </div>
          </div>
          <div class="flex-ns justify-center">
            <div class="w-50-ns w-100 pa2-ns pa1 flex flex-column"
                 :class="{'input-margin': $v.phone.$error && !$v.dni.$error}">
              <span class="dark-red f7" v-if="$v.dni.$error && !$v.dni.required">{{ $t("error.idRequired") }}</span>
              <label class="f7 textColor" for="dni">{{ $t("users.id") }}</label>
              <input class="w-100 input ph2" :class="{error: $v.dni.$error}"
                     @blur="$v.dni.$touch" v-model="dni" name="dni" id="dni" :placeholder="$t('users.id')"
                     :disabled="!edit">
            </div>
            <div class="w-50-ns w-100 pa2-ns pa1 flex flex-column"
                 :class="{'input-margin': $v.dni.$error && !$v.phone.$error}">
              <span class="dark-red f7"
                    v-if="$v.phone.$error && !$v.phone.numeric">{{ $t("error.phoneInvalid") }}</span>
              <label class="f7 textColor" for="phone">{{ $t("users.phone") }}</label>
              <input class="w-100 input ph2" :class="{error: $v.phone.$error}" :disabled="!edit"
                     @blur="$v.phone.$touch" v-model="phone" name="phone" id="phone" :placeholder="$t('users.phone')">
            </div>
          </div>
          <div class="flex-ns db justify-left">
            <div class="w-50-ns w-100 pa2-ns pa1 flex flex-column"
                 :class="{'input-margin': $v.email2.$error && !$v.email.$error}">
              <span class="dark-red f7" v-if="error && input === 'email'">{{error}}</span>
              <span class="dark-red f7" v-if="$v.email.$error && !$v.email.required">{{ $t("error.emailRequired")
                }}</span>
              <span class="dark-red f7" v-if="$v.email.$error && !$v.email.email">{{ $t("error.emailInvalid") }}</span>
              <label class="f7 textColor" for="email">{{ $t("users.email") }}</label>
              <input class="w-100 input ph2" :class="{'error': $v.email.$error || (error && input === 'email')}"
                     @blur="$v.email.$touch" v-model="email" name="email" id="email" :placeholder="$t('users.email')"
                     :disabled="true">
            </div>
          </div>
          <div class="flex flex-column pa2-ns pa1 w-100">
            <span class="dark-red f7"
                  v-if="$v.address.$error && !$v.address.required">{{ $t("error.addressRequired") }}</span>
            <label class="f7 textColor" for="address">{{ $t("users.address") }}</label>
            <input class="input ph2" :class="{error: $v.address.$error}" @blur="$v.address.$touch"
                   v-model="address" name="address" id="address" :placeholder="$t('users.address')" :disabled="!edit">
          </div>
          <div class="flex-ns justify-center">
            <div class="w-50-ns w-100 pa2-ns pa1 flex flex-column">
              <label class="f7 textColor" for="country">{{ $t("users.country") }}</label>
              <select class="w-100 block ph1 pv2 input" v-model="country" id="country" :disabled="!edit">
                <option v-for="country in countries" :track-by="country.alpha2Code" :key="country.alpha2Code"
                        :value="country.alpha2Code">{{ country.name }}
                </option>
              </select>
            </div>
            <div class="w-50-ns w-100 pa2-ns pa1">
              <label class="f7 textColor" for="city">{{$t("users.city")}}</label>
              <input class="w-100 input ph2" v-model="city" name="city" id="city" :placeholder="$t('users.city')"
                     :disabled="!edit">
            </div>
          </div>
          <div class="flex">
          <span class="dark-red f7 mh2-ns" v-if="($v.day.$error && !$v.day.required) || ($v.month.$error && !$v.month.required) ||
          ($v.year.$error && !$v.year.required)">{{ $t("error.bithdateRequired") }}</span>
          </div>
          <label class="mh2-ns f7 textColor">{{$t("users.birthdate")}}</label>
          <div class="flex-ns justify-between items-center">
            <select class="w-third-ns w-100 mh2-ns block ph1 pv2 input" :class="{error: $v.day.$error}"
                    @blur="$v.day.$touch"
                    v-model="day" id="birth-day" :disabled="!edit">
              <option disabled value="" selected>Día</option>
              <option v-for="n in 31" :track-by="n" :key="n" :value="n">{{n}}</option>
            </select>
            <select class="w-third-ns w-100 mh2-ns block ph1 pv2 input" :class="{error: $v.month.$error}"
                    @blur="$v.month.$touch"
                    v-model="month" id="birth-month" :disabled="!edit">
              <option disabled value="" selected>Mes</option>
              <option v-for="(item, index) in months" :track-by="index" :key="index" :value="index">{{item}}</option>
            </select>
            <select class="w-third-ns w-100 mh2-ns block ph1 pv2 input textColor" :class="{error: $v.year.$error}"
                    @blur="$v.year.$touch"
                    v-model="year" id="birth-year" :disabled="!edit">
              <option disabled value="" selected>Año</option>
              <option v-for="n in 80" :track-by="n" :key="n" :value="currentYear - n">{{currentYear - n}}</option>
            </select>
          </div>
          <div class="mv2 flex-ns justify-center items-center">
            <label class="ma2 ttu textColor">
              <input v-model="userType" name="user_type" type="radio" value="0"
                     :disabled="!edit">{{ $t("users.userType.musicFan") }}
            </label>
            <label class="ma2 ttu textColor">
              <input v-model="userType" name="user_type" type="radio" value="1" :disabled="!edit">
              {{ $t("users.userType.producer") }}
            </label>
          </div>

          <div class="flex flex-column w-100 pa2-ns pa1">
            <label class="f7 textColor" for="bio">{{ $t("users.bio") }}</label>
            <textarea class="ph2 input" v-model="bio" name="bio" id="bio" :placeholder="$t('users.bioDescription')"
                      :disabled="!edit"/>
          </div>

          <div class="mv2 display-c justify-center items-center">
            <label class="ma2 ttu textColor">
              <input v-model="acceptNewsLetter" name="accept_news_letter" type="checkbox" value="1"
                     :disabled="!edit">{{ $t("users.accept.newsLetter") }}
            </label>
            <label class="ma2 ttu textColor">
              <input v-model="acceptShareInfo" name="accept_share_info" type="checkbox" value="1" :disabled="!edit">
              {{ $t("users.accept.shareInfo") }}
            </label>
          </div>

          <div v-show="edit" class="flex justify-center">
            <input class="w-30-l w-50-m w-100 block mv2 pointer btn dim b f5 fw4 textColor" type="submit"
                   :value="$t('app.save')">
          </div>
        </div>
      </form>
    </div>
    <div v-if="canRefer" class="mtb-30">
      <div class="flex list-group-horizontal items-center mh2 w-100">
        <button @click="genToken" class="genCode" :disabled="disableButton">{{$t('users.generateReferralCode')}}</button>
        <input contenteditable="true" readonly class="w-38 block ma2 ph1 pv2 input h2 textColor brad-100" v-model="link"/>
        <button class="btn w-4 pd-4 pointer" v-clipboard="link"
          @success="clipboardLinkSuccess"
          @error="clipboardError"><font-awesome-icon class="white" icon="copy"/>
        </button>
        <input contenteditable="true" readonly class="w-19 block ma2 ph1 pv2 input textColor h2 brad-100" v-model="rcode"/>
        <button class="btn w-4 pd-4 pointer" v-clipboard="rcode"
          @success="clipboardCodeSuccess"
          @error="clipboardError"><font-awesome-icon class="white" icon="copy"/>
        </button>
      </div>
    </div>
    <my-artist-info v-if="isProducer" :edit="edit"></my-artist-info>
    <div v-if="user">
      <div class="flex flex-column items-start-l items-center" v-if="user.subscription">
        <div v-if="user.subscription.active">
          <div v-if="subscriptionGateway">
            <h3 class="textColor">{{$t('users.subscription.cancelSubscription')}}</h3>
            <div>
              <button @click="mpCancelSubscription" class="w-50-ns w-100 block mv2 pointer btn dim b f5 fw4">{{$t('users.subscription.disaffiliate')}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-column items-start-l items-center" >
        <div>
          <div>
            <p class="textColor pointer underline" @click="deleteAccount">{{$t('users.subscription.cancelAccount')}}</p>
          </div>
        </div>
      </div>
    </div>
    <!--<vue-confirm-dialog></vue-confirm-dialog>-->
  </div>
</template>

<script>
  import {required, email, numeric, sameAs} from 'vuelidate/lib/validators'
  import {mapGetters, mapActions} from 'vuex'
  import countries from '@/countries'
  import MyArtistInfo from './MyArtistInfo.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import consts from '@/consts'

  export default {
    name: 'my-info',
    data () {
      return {
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre',
          'Noviembre', 'Diciembre'],
        username: '',
        name: '',
        surname: '',
        password: '',
        password2: '',
        dni: '',
        phone: '',
        email: '',
        email2: '',
        address: '',
        day: '',
        month: '',
        year: '',
        userType: 0,
        bio: '',
        country: '',
        city: '',
        edit: true,
        color: '#808080',
        size: '30px',
        countries: countries.countries,
        currentYear: (new Date()).getFullYear(),
        subscriptionGateway: null,
        acceptNewsLetter: 1,
        acceptShareInfo: 1,
        link: '',
        rcode: '',
        disableButton: false
      }
    },
    components: {
      FontAwesomeIcon,
      ClipLoader,
      MyArtistInfo
    },
    created () {
      if (this.user) {
        this.username = this.user.user_name
        this.name = this.user.first_name
        this.surname = this.user.last_name
        this.dni = this.user.dni
        this.email = this.user.email
        this.email2 = this.user.email
        this.address = this.user.direccion
        this.phone = this.user.telefono
        this.userType = this.user.user_type
        this.bio = this.user.bio
        this.country = this.user.country
        this.city = this.user.city
        if (this.user.birth) {
          let bd = this.user.birth.split('-')
          this.year = bd[0]
          this.month = bd[1] - 1
          this.day = bd[2]
        }
        this.acceptNewsLetter = this.user.accept_news_letter
        this.acceptShareInfo = this.user.accept_share_info
      }
      this.checkSubscriptionGateway().then(res => {
        this.subscriptionGateway = res
      })
    },
    mounted () {
      this.checkMyActiveUserReferredPlan().then(res => {
        if (res) {
          this.link = consts.BASE_HOST + '?referredCode=' + res.code
          this.rcode = res.code
          this.disableButton = true
        } else { this.disableButton = false }
      })
    },
    watch: {
      user (newVal) {
        if (newVal !== null) {
          this.username = newVal.user_name
          this.name = this.user.first_name
          this.surname = this.user.last_name
          this.dni = newVal.dni
          this.email = newVal.email
          this.email2 = newVal.email
          this.address = newVal.direccion
          this.phone = newVal.telefono
          this.userType = newVal.user_type
          this.bio = newVal.bio
          this.country = newVal.country
          this.city = newVal.city

          let bd = this.user.birth.split('-')
          this.year = bd[0]
          this.month = bd[1] - 1
          this.day = bd[2]
          this.acceptNewsLetter = newVal.accept_news_letter
          this.acceptShareInfo = newVal.accept_share_info
        }
      }
    },
    computed: {
      ...mapGetters('user', [
        'error',
        'loading',
        'input',
        'validVoucher',
        'user',
        'isProducer',
        'referredCode',
        'isSubscribed'
      ]),
      canRefer () {
        console.log(this.user.id)
        if (this.user && this.user.user_type !== 0 && this.isSubscribed) {
          if (this.user.subscription) {
            if (this.user.subscription.pricing) {
              if (this.user.subscription.pricing.id === 1) {
                return true
              } else { return false }
            } else { return false }
          } else { return false }
        } else { return false }
      }
    },
    methods: {
      ...mapActions('user', [
        'register',
        'checkVoucher',
        'resetError',
        'editUser',
        'checkSubscriptionGateway',
        'cancelBeatheySuscription',
        'saveReferredCode',
        'checkMyActiveUserReferredPlan',
        'deleteBeatheyAccount',
        'logout'
      ]),
      editTrigger () {
        // this.edit = !this.edit
      },
      updateUser () {
        if (!this.$v.$invalid) {
          this.editUser({
            username: this.username,
            password: this.password,
            name: this.name,
            surname: this.surname,
            dni: this.dni,
            phone: this.phone,
            email: this.email,
            address: this.address,
            birthdate: this.year + '-' + (parseInt(this.month) + 1) + '-' + this.day,
            userType: this.userType,
            country: this.country,
            city: this.city,
            bio: this.bio,
            acceptNewsLetter: this.acceptNewsLetter,
            acceptShareInfo: this.acceptShareInfo
          }).then(() => {
            this.editTrigger()
            this.$toasted.show(this.$t('users.editSuccess'), {type: 'success'})
          }).catch((e) => {
            this.$toasted.show(this.error, {type: 'error'})
          })
        } else {
          this.$v.$touch()
        }
      },
      mpCancelSubscription () {
        if (this.user.subscription.pricing.id === 2 && this.user.country === 'PER') {
          // added so telco users of Peru unsuscribe from correct link
          window.location.href = 'https://peentel-hub.wazzupmobile.com/#/out?productId=1000007285'
          return window.location.href
        }
        if (this.subscriptionGateway.gateway === 'mercadopago') {
          this.$modal.show('dialog', {
            title: this.$t('users.subscription.cancelTitle'),
            text: this.$t('users.subscription.cancelMessage'),
            buttons: [
              {
                title: this.$t('users.subscription.confirm'),
                handler: () => {
                  this.cancelBeatheySuscription().then(res => {
                    if (res === 'You can not modify a cancelled preapproval.') {
                      this.$toasted.show(this.$t('users.subscription.canceledMPsubError'), {type: 'error'})
                      this.$modal.hide('dialog')
                    }
                    if (res) {
                      if (res === 'cancelled') {
                        this.$toasted.show(this.$t('users.subscription.canceledMPsubSuccess'), {type: 'success'})
                        this.$modal.hide('dialog')
                        location.reload()
                      }
                    }
                  })
                }
              },
              {
                title: this.$t('users.subscription.reject'),
                default: true,
                handler: () => {
                  this.$modal.hide('dialog')
                }
              }
            ]
          })
        }
      },
      genToken () {
        let URL = consts.BASE_HOST
        this.rcode = this.random()
        if (URL === 'http://localhost') {
          this.link = consts.BASE_HOST + ':8081' + '?referredCode=' + this.rcode
        } else {
          this.link = consts.BASE_HOST + '?referredCode=' + this.rcode
        }
        this.saveReferredCode(this.rcode).then(res => {
          if (res) {
            this.link = this.link = consts.BASE_HOST + '?referredCode=' + res.code
            this.rcode = res.code
            this.disableButton = true
          } else { this.disableButton = false }
        })
      },
      random () {
        return (Math.random().toString(16).substr(2)) + (Math.random().toString(16).substr(2))
      },
      clipboardLinkSuccess () {
        this.$toasted.show(this.$t('users.copyLinkSucces'), {type: 'success'})
      },
      clipboardCodeSuccess () {
        this.$toasted.show(this.$t('users.copyCodeSucces'), {type: 'success'})
      },
      clipboardError () {
        this.$toasted.show(this.$t('users.copyError'), {type: 'error'})
      },
      deleteAccount () {
        this.$modal.show('dialog', {
          title: this.$t('users.subscription.cancelTitle'),
          text: this.$t('users.subscription.cancelAccountMessage'),
          buttons: [
            {
              title: this.$t('users.subscription.confirm'),
              handler: () => {
                this.deleteBeatheyAccount().then(res => {
                  if (!res) {
                    this.$toasted.show(this.$t('users.subscription.cancelAccountError'), {type: 'error'})
                    this.$modal.hide('dialog')
                  }

                  if (res) {
                    this.$toasted.show(this.$t('users.subscription.cancelAccountSuccess'), {type: 'success'})
                    this.$modal.hide('dialog')
                    this.$auth0.logout()
                    this.logout()
                    this.$router.push({path: '/'})
                  }
                })
              }
            },
            {
              title: this.$t('users.subscription.reject'),
              default: true,
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      }
    },
    validations: {
      username: {
        required
      },
      dni: {
        required
      },
      phone: {
        numeric
      },
      email: {
        required,
        email
      },
      email2: {
        required,
        sameAsEmail: sameAs('email')
      },
      password2: {
        sameAsEmail: sameAs('password')
      },
      day: {
        required
      },
      month: {
        required
      },
      year: {
        required
      },
      address: {
        required
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .input {
    color: #aaa !important;
    border: 1px solid #DDDEDF;
  }

  .edit-button {
    width: 50px;
    height: 50px;
  }

  .display-c {
    display: contents;
  }

  .w-4 {
    width: 4%;
  }

  .w-38 {
    width: 38%;
  }

  .w-19{
    width: 19%;
  }

  .pd-4 {
    padding: 4.5px;
  }

  .genCode {
    cursor: pointer;
    padding: 8px 10px;
    border: 1px solid #E6007E;
    border-radius: 100px;
    background: none;
    color: #fff;
  }

  .brad-100 {
    border-radius: 100px;
  }

  .mtb-30 {
    margin: 30px 0px;
  }

  @media (min-width: 479px) {
    .input-margin {
      margin-top: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/MyInfo.vue